<template>
    <div>
        <vx-input v-if="valueInvalid" v-model="textValue" v-bind="attrs" v-on="listeners" />
        <vx-select v-else v-model="state" v-bind="attrs" v-on="listeners" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'vx-state-select',
    props: {
        value: {
            type: [Object, Number, String]
        },
        valueIsId: {
            type: Boolean,
            default: false
        },
        valueIsText: {
            type: Boolean,
            default: false
        },
        preventUnknown: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        valueInvalid: {
            handler: function (newV, oldV) {
                if (newV) {
                    this.textValue = this.value
                    return
                }
                this.textValue = null
            },
            immediate: true
        }
    },
    data() {
        return {
            textValue: null
        }
    },
    computed: {
        ...mapGetters({
            getStateByCode: 'maarima/getStateByCode',
            getStateById: 'maarima/getStateById',
            states: 'maarima/states'
        }),
        valueInvalid() {
            return !!this.value && !this.state
        },
        states_x() {
            return this.states.where((s) => s.id != -1)
        },
        state: {
            get() {
                if (!this.value) {
                    return null
                } else if (this.valueIsId) {
                    return this.getStateById(this.value)
                } else if (this.valueIsText) {
                    return this.getStateByCode(this.value)
                }
                return this.value
            },
            set(v) {
                var actual = v
                // while in an error state, allow manual modification of the string
                // this allow bad pronto data to be displayed, saved and edited.
                if (typeof actual == 'string') {
                    this.textValue = actual
                    v = this.getStateByCode(actual)
                }
                if (!v) {
                    v = null
                } else if (this.valueIsId) {
                    v = v.id
                } else if (this.valueIsText) {
                    v = v.shortName
                }
                this.$emit('input', v || actual)
            }
        },
        attrs() {
            return {
                'name': 'state',
                'label': 'State',
                ...this.$attrs,
                'value': this.state,
                'text-key': 'shortName',
                'options': this.states,
                'autocomplete': true
            }
        },
        listeners() {
            return {
                ...this.$listeners,
                input: this.setState
            }
        }
    },
    methods: {
        setState(newState) {
            this.state = newState
        }
    }
}
</script>

<style lang="scss" scoped></style>
